import { render } from "./BusinessItem.vue?vue&type=template&id=f76bb2c2&scoped=true"
import script from "./BusinessItem.vue?vue&type=script&lang=js"
export * from "./BusinessItem.vue?vue&type=script&lang=js"

import "./BusinessItem.vue?vue&type=style&index=0&id=f76bb2c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f76bb2c2"]])

export default __exports__